//redondear el numero a dos decimas y formateo de cada 3 posiciones una ,  
export function roundigFormat(number = 0) {//41699733.28
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'SOL', currencyDisplay: 'narrowSymbol' }).format(number);
}

export function getFieldAccType(field) {
    let AccType = ''
    switch (field) {
        case 'ExpensesAc':
        case 'BalInvntAc':
        case 'SaleCostAc':
        case 'TransferAc':
        case 'VarianceAc':
        case 'PriceDifAc':
        case 'DecreasAc':
        case 'IncreasAc':
        case 'ReturnAc':
        case 'FrExpensAc':
        case 'DecresGlAc':
        case 'IncresGlAc':
        case 'WipAcct':
        case 'WipVarAcct':
        case 'StokRvlAct':
        case 'StkOffsAct':
        case 'CostRvlAct':
        case 'CstOffsAct':
        case 'StkInTnAct':
        case 'APCMAct':
        case 'APCMFrnAct':

            AccType = 'N'
            break;

            
        case 'RevenuesAc':
        case 'FrRevenuAc':
        case 'ExchangeAc':
        case 'BalanceAcc':
        case 'ARCMAct':
        case 'ARCMFrnAct':

            AccType = 'I'
            break;

        default:
            break;
    }
    /**NOT YET FOUND */
    //NegStckAct
    //WipOffset
    //StockOffst
    //ExpClrAct
    //ShpdGdsAct
    return AccType

}


